/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { I18n } from 'react-redux-i18n';
import InputMask from 'react-input-mask';
import moment from 'moment-timezone';

import ValidatorsHelper from '../../../helpers/validators';
import Pagseguro from '../../../app/services/pagseguro';

class CheckoutPaymentOnlineDebit extends React.Component {
  constructor() {
    super();

    this.state = {
      bankName: '',
      banks: [],
      cnpjError: '',
      cnpj: '',
      phone: '',
      birthDate: '',
    };
  }

  componentDidMount = async () => {
    const onlineDebit = await Pagseguro.getPaymentMethods('ONLINE_DEBIT');

    if (onlineDebit) {
      const banks = Object.keys(onlineDebit.options).reduce((acum, key) => {
        if (onlineDebit.options[key].status === 'AVAILABLE') {
          acum.push({
            name: onlineDebit.options[key].name,
            displayName: `${onlineDebit.options[key].code} - ${onlineDebit.options[key].displayName}`,
          });
        }

        return acum;
      }, [
        {
          name: '',
          displayName: '',
        },
      ]);

      this.setState({ banks: banks || [] });
    }
    if (this.props.paymentService === 'pagseguro') {
      this.checkPersonalData();
    }
  }

  setValue = async (key, value) => {
    if (key === 'birthDate') {
      if (!moment(value).isAfter(moment(new Date()).format('YYYY-MM-DD'))) {
        this.setState({
          [`${key}Error`]: false,
          [key]: value,
        });
      } else {
        this.setState({
          [`${key}Error`]: true,
          [key]: value,
        });
      }
    } else {
      this.setState({
        [`${key}Error`]: '',
        [`${key}Changed`]: true,
        [key]: value,
      });
    }

    if (key === 'cnpj') this.onChangedCnpj(value);
  }

  formatCpnjCpf = (value, opcoRegisterCPF) => {
    if (opcoRegisterCPF && value.length <= 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }

    return value.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  removeMarkCnpjCpf = value => value.replace(/(\.|\/|\-)/g, '');

  onChangedCnpj = (value) => {
    const type = value.length <= 11 ? 'cpf' : 'cnpj';

    if (type === 'cnpj' && ValidatorsHelper.validarCNPJ(value)) {
      this.props.setDocument({ value, type });
      return;
    }
    if (type === 'cpf' && ValidatorsHelper.validarCPF(value)) {
      this.props.setDocument({ value, type });
      return;
    }

    this.props.setDocument({ value: '', type: '' });
  }

  onBlurCnpj = () => {
    const { cnpj } = this.state;
    const type = cnpj.length <= 11 ? 'cpf' : 'cnpj';
    const value = cnpj;

    if (!value.trim()) return;

    if (type === 'cnpj' && !ValidatorsHelper.validarCNPJ(value)) {
      this.setState({ cnpjError: I18n.t('invalidCNPJ') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }
    if (type === 'cpf' && !ValidatorsHelper.validarCPF(value)) {
      this.setState({ cnpjError: I18n.t('invalidCPF') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }

    this.props.setDocument({ value, type });
  }

  renderBankOptions = (banks = []) => {
    if (!banks.length) {
      return (<option key="loading" value="">{I18n.t('loading')}</option>);
    }

    return banks.map(bank => (
      <option key={bank.name} value={bank.name}>{bank.displayName}</option>
    ));
  }

  checkDisabled = (document, bankName) => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.birthDateError === false && this.state.birthDate !== '') {
        return ((!ValidatorsHelper.validDocument(document.type, document.value)) || !bankName);
      }
      return true;
    }
    return ((!ValidatorsHelper.validDocument(document.type, document.value)) || !bankName);
  }

  checkData = async (type, bankName, document) => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.phone.length > 13) {
        this.props.setData({ phone: this.state.phone, birthDate: this.state.birthDate });
        this.props.setPayment(type, { card: { bankName }, document });
      } else {
        await this.setState({
          phoneError: I18n.t('incompletePhoneError'),
        });
      }
    } else {
      this.props.setPayment(type, { card: { bankName }, document });
    }
  }

  checkPersonalData = () => {
    if (this.props.personalData && this.props.personalData.birthDate && !this.state.birthDate) {
      this.setValue('birthDate', this.props.personalData.birthDate);
    }
    if (this.props.personalData && this.props.personalData.phone && !this.state.phone) {
      this.setValue('phone', this.props.personalData.phone);
    }
  }

  render() {
    const {
      bankName, banks, cnpjError, cnpj, phone, birthDate, phoneError, birthDateError,
    } = this.state;
    const { document } = this.props;
    const type = 'debit';

    return (
      <div className="row">
        <div style={{ flex: 1 }}>
          <div style={{ flex: 1 }}>
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('bank')}
                <div className="select select--white">
                  <select
                    defaultValue=""
                    onChange={e => this.setState({ bankName: e.target.value })}
                  >
                    {this.renderBankOptions(banks)}
                  </select>
                </div>
              </label>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <div className="basket-form__group">
              <label className="lbl">
                {I18n.t('loginNewRegisterCnpjCpf')}
                <input
                  tabIndex="-1"
                  className="fld"
                  type="text"
                  value={this.formatCpnjCpf(cnpj, true)}
                  onChange={e => this.setValue('cnpj', this.removeMarkCnpjCpf(e.target.value))}
                  onBlur={this.onBlurCnpj}
                  required
                />
              </label>
              {cnpjError ? (
                <div style={{ height: 50 }}>
                  <p className="error-msg">{cnpjError}</p>
                </div>
              ) : ''}
            </div>
          </div>
          {(this.props.paymentService === 'pagseguro')
            ? (
              <div>
                <div style={{ flex: 1 }}>
                  <div className="basket-form__group">
                    <label className="lbl">
                      {I18n.t('phone2')}
                      <InputMask
                        tabIndex="-1"
                        className="fld"
                        type="text"
                        mask={phone.length > 14 ? '(99) 9 9999-9999' : '(99) 9999-99999'}
                        maskChar={null}
                        value={phone}
                        onChange={e => this.setValue('phone', e.target.value)}
                        required
                      />
                    </label>
                    {phoneError ? (
                      <div style={{ height: 50 }}>
                        <p className="error-msg">{phoneError}</p>
                      </div>
                    ) : ''}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="basket-form__group">
                    <label className="lbl">
                      {I18n.t('birthDate2')}
                      <input
                        tabIndex="-1"
                        className="fld"
                        type="date"
                        value={birthDate}
                        onChange={e => this.setValue('birthDate', e.target.value)}
                        required
                      />
                    </label>
                    {birthDateError ? (
                      <div style={{ height: 50 }}>
                        <p className="error-msg">{I18n.t('errorDateReported')}</p>
                      </div>
                    ) : ''}
                  </div>
                </div>
              </div>
            )
            : ''
          }
          <div style={{ flex: 1 }}>
            <div className="col-12">
              <button
                type="button"
                className="button-action btn btn-secondary"
                disabled={this.checkDisabled(document, bankName)}
                onClick={() => this.checkData(type, bankName, document)}
              >
                {I18n.t('confirm')}
              </button>
            </div>
          </div>
        </div>
        <div style={{ flex: 1 }} />
      </div>
    );
  }
}

export default CheckoutPaymentOnlineDebit;
